import React, { useState } from 'react';

import classNames from 'classnames';

import User from './User';
import ExternalUser from './ExternalUser';
import classes from './styles.module.scss';

export default function SelectedUsers({
  invitedUsers,
  setInvitedUsers,
  withFormik,
  readOnly,
  style,
  isExternalUserList,
}) {
  const [currentUser, setCurrentUser] = useState(null);

  return (
    <div
      className={classNames(classes.SelectedUsers, {
        [classes.readOnly]: readOnly,
      })}
      style={style}
    >
      {invitedUsers &&
        invitedUsers?.map?.((user) => {
          return isExternalUserList ? (
            <ExternalUser
              key={user.value}
              user={user}
              readOnly={readOnly}
              removeUser={() => {
                if (readOnly) return;
                if (withFormik) {
                  setInvitedUsers(
                    invitedUsers.filter((usr) => usr.value !== user.value)
                  );
                  return;
                }

                setInvitedUsers((prevUsers) => {
                  return prevUsers.filter((usr) => usr.value !== user.value);
                });
              }}
              setCurrentUser={setCurrentUser}
            />
          ) : (
            <User
              key={user.value}
              user={user}
              readOnly={readOnly}
              removeUser={() => {
                if (readOnly) return;
                if (withFormik) {
                  setInvitedUsers(
                    invitedUsers.filter((usr) => usr.value !== user.value)
                  );
                  return;
                }

                setInvitedUsers((prevUsers) => {
                  return prevUsers.filter((usr) => usr.value !== user.value);
                });
              }}
              setCurrentUser={setCurrentUser}
            />
          );
        })}
      {currentUser && invitedUsers?.length ? (
        <div className={classes.currentUser}>
          {currentUser.userProfile?.firstName ??
            currentUser.originalData?.firstName}{' '}
          {currentUser.userProfile?.lastName ??
            currentUser.originalData?.lastName}{' '}
          {currentUser.userProfile?.designation ??
          currentUser.originalData?.designation
            ? `(${
                currentUser.userProfile?.designation ??
                currentUser.originalData?.designation
              }) - `
            : ''}
          ({currentUser.userName ?? currentUser.originalData?.email})
        </div>
      ) : null}
    </div>
  );
}
